// extracted by mini-css-extract-plugin
export var heroImage = "_ko-1";
export var modal = "_ko-0";